export default __webpack_public_path__ + "static/media/sld_iphone.a11bcf1d.png";